






import {Component, Prop, Vue, Watch} from "vue-property-decorator";


@Component({
  components: {},
})
export default class Hidden extends Vue {
  // Value passed by v-model
  @Prop() public readonly value: any

   }
